function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();}function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter) {if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);}function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;}}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import { getDayIndexOfWeek } from "redesign/shared/helpers/date-time";
import { getCurrentDay } from "../../shared/helpers/date-time";

var _private = {
  mealPlan: null,
  firebaseMealsTips: null,
  firebaseMeals: {},
  promise: null };


export var MealPlanService = /*#__PURE__*/function () {MealPlanService.$inject = ["$q", "$rootScope", "$timeout", "$interval", "ApiFirebase", "MealPlanModel", "UserService", "UserMealItemModel", "TipModel", "MiscModel", "MeasurementSystem", "UnitRangeService", "Sync"];
  function MealPlanService($q, $rootScope, $timeout, $interval, ApiFirebase, MealPlanModel, UserService, UserMealItemModel, TipModel,
  MiscModel, MeasurementSystem, UnitRangeService, Sync) {
    "ngInject";var _this = this;_classCallCheck(this, MealPlanService);
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.ApiFirebase = ApiFirebase;
    this.UserService = UserService;
    this.MealPlanModel = MealPlanModel;
    this.UserMealItemModel = UserMealItemModel;
    this.TipModel = TipModel;
    this.MiscModel = MiscModel;
    this.MeasurementSystem = MeasurementSystem;
    this.UnitRangeService = UnitRangeService;
    _private.mealPlan = new MealPlanModel();

    // this.$rootScope.$watch(()=>Sync.initialized,(firebaseInitialized)=>{
    //   if (!firebaseInitialized) return false;
    // });
    var firebaseInterval = $interval(function () {
      if (Sync.initialized) {
        $interval.cancel(firebaseInterval);
        _this.ApiFirebase.getUserMealTip(UserService.data.intercom_id).
        then(function (res) {
          _this.mealTipsFirebaseObject = res;
          _this.mealTipsFirebaseObject.$ref().on('value', function (snapshot) {
            _this.onFirebaseMealTipsData(snapshot.val());
          });
        }).
        catch(function (err) {
          console.warn('error', err);
        });



        _this.ApiFirebase.getUserMeals(UserService.data.intercom_id).
        then(function (res) {
          _this.userMealsFirebaseObject = res;
          _this.userMealsFirebaseObject.$ref().on('value', function (snapshot) {
            _this.onFirebaseUserMealsData(snapshot.val());
          });
        }).
        catch(function (err) {
          console.warn('error', err);
        });

      }
    }, 100);
  }

  /**
     * @returns {MealPlan}
     */_createClass(MealPlanService, [{ key: "onFirebaseUserMealsData", value: function onFirebaseUserMealsData(




































    firebaseUserMeals) {
      console.warn('firebase user_meals', firebaseUserMeals, this.userMealsFirebaseObject);
      if (!firebaseUserMeals) {
        _private.firebaseMeals = {};
        return false;
      }
      _private.firebaseMeals = angular.copy(firebaseUserMeals);
      this.mergeMealPlanWithFirebaseMeals();
    } }, { key: "onFirebaseMealTipsData", value: function onFirebaseMealTipsData(

    firebaseTip) {
      console.warn('firebase tip', firebaseTip, this.mealTipsFirebaseObject);
      if (firebaseTip && firebaseTip.id) {
        _private.firebaseMealsTips = angular.copy(firebaseTip);
        this.setFirebaseTipToMeal();
      }
    }

    /**
       * @returns {Promise} async get meal-plan instance
       */ }, { key: "getMealPlan", value: function getMealPlan()
    {
      return this.promise ?
      this.promise :
      this.mealPlan.days.length ?
      this.$q.resolve(this.mealPlan) :
      this.fetch();

    } }, { key: "getMealsByLabelForRecipe", value: function getMealsByLabelForRecipe(

    mealLabel, mealNumber, recipeId) {
      return this.mealPlan.getMealsByLabelForRecipe(mealLabel, mealNumber, recipeId);
    } }, { key: "getMealByLoggedMealId", value: function getMealByLoggedMealId(

    mealId) {
      return this.mealPlan.getMealByLoggedMealId(mealId);
    }

    /**
       * @param mealId
       * @returns {Meal | undefined}
       */ }, { key: "getMealById", value: function getMealById(
    mealId) {
      return this.mealPlan.getMealById(mealId);
    } }, { key: "setFirebaseTipToMeal", value: function setFirebaseTipToMeal()

    {
      var tip = _private.firebaseMealsTips;
      if (tip && tip.delivery_place != 'app_general') {
        var mealId = parseInt(tip.delivery_place_id);
        this.mealWithTip = this.getMealByLoggedMealId(mealId);
      }
      if (!(this.mealWithTip && tip)) return;
      this.mealWithTip.tip = tip;
      this.$rootScope.$emit('meal-tips');
    } }, { key: "setTipToMeal", value: function setTipToMeal(

    tip) {
      var mealId = parseInt(tip.delivery_place_id);
      this.mealWithTip = this.getMealByLoggedMealId(mealId);
      if (!(this.mealWithTip && tip)) return;
      this.mealWithTip.tip = tip;
    } }, { key: "setShopifyProducts", value: function setShopifyProducts()

    {
      for (var k = 0; k < _private.mealPlan.days.length; k++) {
        var day = _private.mealPlan.days[k];
        for (var i = 0; i < day.meals.length; i++) {
          var meal = day.meals[i];
          meal.shopifyProduct = -1;
          for (var j = 0; j < meal.meal_items.length; j++) {
            var meal_item = meal.meal_items[j];
            if (meal_item.name == 'whey protein powder pfc') {
              meal.shopifyProduct = j;
            }
          }
        }
      }
    } }, { key: "fetch", value: function fetch()

    {var _this2 = this;var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      //if (_private.promise) return _private.promise;
      var req1;
      if (params.week_number) {
        req1 = this.MealPlanModel.findByWeekNumber(params);
      } else {
        req1 = this.MealPlanModel.query();
      }
      var req2 = this.MeasurementSystem.getMeasurementSystem();
      var req3 = this.UnitRangeService.getUnitsRange();
      _private.promise = this.$q.all([req1, req2, req3]).
      then(function (res) {
        var mealPlan = res[0];
        _this2.mesSystem = res[1];
        _this2.foodsRange = res[2];
        _private.mealPlan.$update(mealPlan);
        _this2.mergeMealPlanWithFirebaseMeals();
        _this2.prepareMealToModal();
        _this2.setShopifyProducts();
        _this2.setMealTips();
        return _private.mealPlan;
      }).
      catch(function (err) {
        console.warn('MealPlanService fetch failed');
        throw err;
      }).
      finally(function () {
        _private.promise = null;
      });

      return _private.promise;
    } }, { key: "setMealTips", value: function setMealTips()

    {var _this3 = this;
      this.TipModel.query().
      then(function (tips) {
        _this3.tips = tips;

        _this3.MiscModel.get('ViewedTipIDs').then(
        function (misc) {
          _this3.viewedTipIDs = JSON.parse(misc.value);

          for (var i = 0; i < _this3.tips.length; i++) {
            var tip = _this3.tips[i];
            if (tip.delivery_place_id) {
              if (_this3.viewedTipIDs.indexOf(tip.id) == -1) {
                tip.show_badge = true;
              } else
              {
                tip.show_badge = false;
              }
              _this3.setTipToMeal(tip);
            }
          }

        },
        function (err) {
          for (var i = 0; i < _this3.tips.length; i++) {
            var tip = _this3.tips[i];
            if (tip.delivery_place_id) {
              tip.show_badge = true;
              _this3.setTipToMeal(tip);
            }
          }
        });

      });
    } }, { key: "prepareMealToModal", value: function prepareMealToModal()

    {
      for (var dayIndex = 0; dayIndex < _private.mealPlan.days.length; dayIndex++) {
        var day = _private.mealPlan.days[dayIndex];
        for (var mealIndex = 0; mealIndex < day.meals.length; mealIndex++) {
          var meal = day.meals[mealIndex];
          meal.modal_calories = meal.calories;
          meal.modal_fats = meal.fats;
          meal.modal_carbohydrates = meal.carbohydrates;
          meal.modal_proteins = meal.proteins;
          for (var k = 0; k < meal.meal_items.length; k++) {
            var meal_item = meal.meal_items[k];
            meal_item.modal_calories = meal_item.calories;
            meal_item.modal_fats = meal_item.fats;
            meal_item.modal_carbohydrates = meal_item.carbohydrates;
            meal_item.modal_proteins = meal_item.proteins;
            meal_item.range = [];
            if (['extra', 'free'].indexOf(meal_item.category) == -1 && this.mesSystem == 'US' && this.foodsRange.hasOwnProperty(meal_item.name)) {
              var foodRange = this.foodsRange[meal_item.name];
              meal_item.range = foodRange.range;
              meal_item.representation_type = foodRange.representation_type;
            }
          }
          meal.logged_proteins = 0;
          meal.logged_carbohydrates = 0;
          meal.logged_fats = 0;
          for (var _k = 0; _k < meal.logged_meal_items.length; _k++) {
            var _meal_item = meal.logged_meal_items[_k];
            meal.logged_proteins += _meal_item.proteins;
            meal.logged_carbohydrates += _meal_item.carbohydrates;
            meal.logged_fats += _meal_item.fats;
            _meal_item.range = [];
            if (['extra', 'free'].indexOf(_meal_item.category) == -1 && this.mesSystem == 'US' && this.foodsRange.hasOwnProperty(_meal_item.name)) {
              var _foodRange = this.foodsRange[_meal_item.name];
              _meal_item.range = _foodRange.range;
              _meal_item.representation_type = _foodRange.representation_type;
            }
          }
          meal.logged_proteins = parseFloat(meal.logged_proteins.toFixed(2));
          meal.logged_carbohydrates = parseFloat(meal.logged_carbohydrates.toFixed(2));
          meal.logged_fats = parseFloat(meal.logged_fats.toFixed(2));
        }
      }
    } }, { key: "mergeMealPlanWithFirebaseMeals", value: function mergeMealPlanWithFirebaseMeals()

    {
      if (!_private.mealPlan.days.length || !Object.keys(_private.firebaseMeals || {}).length) {
        console.warn('firebase merge not ready');
        return false;
      }
      console.log(_private.mealPlan.days[0].meals[0].week_number);
      Object.keys(_private.firebaseMeals).forEach(function (mealId) {var _ref =
        _private.firebaseMeals[mealId] || {},version_num = _ref.version_num,meal_object = _ref.meal_object;
        var $apiMeal = _private.mealPlan.getMealById(Number(mealId));
        if (!meal_object || !$apiMeal) {
          return false;
        }
        meal_object.customMeal && ($apiMeal.customMeal = meal_object.customMeal);
        meal_object.meal_items && meal_object.meal_items.length && ($apiMeal.meal_items = meal_object.meal_items);
        meal_object.extra_items && meal_object.extra_items.length && ($apiMeal.meal_items = $apiMeal.meal_items.concat(meal_object.extra_items));

        $apiMeal.calories = 0;
        $apiMeal.fats = 0;
        $apiMeal.carbohydrates = 0;
        $apiMeal.proteins = 0;

        $apiMeal.modal_calories = 0;
        $apiMeal.modal_fats = 0;
        $apiMeal.modal_carbohydrates = 0;
        $apiMeal.modal_proteins = 0;

        for (var k = 0; k < $apiMeal.meal_items.length; k++) {
          var meal_item = $apiMeal.meal_items[k];
          if (!meal_item.deleted) {
            $apiMeal.calories += parseFloat(meal_item.calories);
            $apiMeal.fats += parseFloat(meal_item.fats);
            $apiMeal.carbohydrates += parseFloat(meal_item.carbohydrates);
            $apiMeal.proteins += parseFloat(meal_item.proteins);
            $apiMeal.modal_calories += parseFloat(meal_item.modal_calories);
            $apiMeal.modal_fats += parseFloat(meal_item.modal_fats);
            $apiMeal.modal_carbohydrates += parseFloat(meal_item.modal_carbohydrates);
            $apiMeal.modal_proteins += parseFloat(meal_item.modal_proteins);
          }
        }

        $apiMeal.calories = parseFloat($apiMeal.calories.toFixed(2));
        $apiMeal.fats = parseFloat($apiMeal.fats.toFixed(2));
        $apiMeal.carbohydrates = parseFloat($apiMeal.carbohydrates.toFixed(2));
        $apiMeal.proteins = parseFloat($apiMeal.proteins.toFixed(2));
        $apiMeal.modal_calories = parseFloat($apiMeal.modal_calories.toFixed(2));
        $apiMeal.modal_fats = parseFloat($apiMeal.modal_fats.toFixed(2));
        $apiMeal.modal_carbohydrates = parseFloat($apiMeal.modal_carbohydrates.toFixed(2));
        $apiMeal.modal_proteins = parseFloat($apiMeal.modal_proteins.toFixed(2));
      });
      console.warn('MealPlan merged with firebase');
    } }, { key: "makeWeekSwap", value: function makeWeekSwap(

    food, mealItemName, weekNumber, mealPlan) {var _this4 = this;
      var reqs = [];
      for (var i = 0; i < mealPlan.days.length; i++) {
        var day = mealPlan.days[i];
        for (var j = 0; j < day.meals.length; j++) {
          var meal = day.meals[j];
          for (var k = 0; k < meal.meal_items.length; k++) {
            var meal_item = meal.meal_items[k];
            if (meal_item.name == mealItemName) {
              var userMealItem = new this.UserMealItemModel(_objectSpread({},
              food, {
                calories: food.calories * meal_item.exchanges,
                proteins: food.proteins * meal_item.exchanges,
                fats: food.fats * meal_item.exchanges,
                carbohydrates: food.carbohydrates * meal_item.exchanges,
                id: meal_item.id,
                meal: meal.id,
                exchanges: meal_item.exchanges }));

              userMealItem.amount = userMealItem.amount_si = null;
              reqs.push(userMealItem.$save());
            }
          }
        }
      }
      return this.$q.all(reqs).then(function (res) {
        var l = 0;
        for (var _i = 0; _i < mealPlan.days.length; _i++) {
          var _day = mealPlan.days[_i];
          for (var _j = 0; _j < _day.meals.length; _j++) {
            var _meal = _day.meals[_j];
            for (var _k2 = 0; _k2 < _meal.meal_items.length; _k2++) {
              var _meal_item2 = _meal.meal_items[_k2];
              if (_meal_item2.name == mealItemName) {
                var meal_imem_swapped = res[l];
                if (['extra', 'free'].indexOf(meal_imem_swapped.category) == -1 && _this4.mesSystem == 'US' && _this4.foodsRange.hasOwnProperty(meal_imem_swapped.name)) {
                  var foodRange = _this4.foodsRange[meal_imem_swapped.name];
                  meal_imem_swapped.range = foodRange.range;
                  meal_imem_swapped.representation_type = foodRange.representation_type;
                }
                mealPlan.days[_i].meals[_j].meal_items[_k2] = meal_imem_swapped;
                l += 1;
                _this4.ApiFirebase.updateOrCreateUserMeal(_this4.UserService.data.intercom_id, mealPlan.days[_i].meals[_j]);
              }
            }
          }
        }
        if (weekNumber == _this4.UserService.data.last_checkin.week_number) {
          return _this4.fetch();
        } else
        {
          _this4.$rootScope.$emit('week-swap');
          return _this4.fetch({ week_number: weekNumber });
        }
        console.warn('swap ok', res);
      }).
      catch(function (err) {
        console.warn('swap error', err);
      });
    } }, { key: "weekSwap", value: function weekSwap(

    food, mealItemName, weekNumber) {
      return this.makeWeekSwap(food, mealItemName, weekNumber, _private.mealPlan);
    } }, { key: "mealPlan", get: function get() {return _private.mealPlan;} /**
                                                                             * @returns {Promise | null} current loading promise
                                                                             */ }, { key: "promise", get: function get() {return _private.promise;} /**
                                                                                                                                                     * @returns {MealPlanDay | undefined}
                                                                                                                                                     */ }, { key: "mealPlanForToday", get: function get() {return _private.mealPlan.days[this.currentDayIndex];} /**
                                                                                                                                                                                                                                                                  * @returns {Meal | undefined}
                                                                                                                                                                                                                                                                  */ }, { key: "lastTrackedMeal", get: function get() {var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {for (var _iterator = _toConsumableArray(this.mealPlanForToday && this.mealPlanForToday.meals || []).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var meal = _step.value;if (meal.logged) return meal;}} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return != null) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * @returns {number} day index in week
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */ }, { key: "currentDayIndex", get: function get() {return this.UserService.currentDayIndex;} }]);return MealPlanService;}();